import { Component, Inject, LOCALE_ID } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HeadManipulateService } from 'src/app/services/utils/head-manipulate.service';
import { ServerSideResponseService } from 'src/app/services/utils/not-found-service';
import { MobileNotFoundComponent } from '../../mobile-not-found/mobile-not-found.component';
import { Router } from '@angular/router';
import { LICENCE } from 'src/app/global.tokens';

@Component({
  selector: 'app-desktop-not-found-page',
  templateUrl: './desktop-not-found-page.component.html',
  styleUrls: ['./desktop-not-found-page.component.scss']
})
export class DesktopNotFoundPageComponent extends MobileNotFoundComponent {

  constructor(
    protected ssr: ServerSideResponseService,
    protected manipulateHeaderService: HeadManipulateService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    protected apollo: Apollo,
    protected router: Router
  ) {
    super(ssr, manipulateHeaderService, locale, licence, apollo, router);
    this.ssr.setNotFound();
    const url = decodeURIComponent(this.router.url);

    if (url !== this.router.url) {
      this.router.navigateByUrl(url);
    }
  }

  ngOnInit(): void {
    this.setTags();
  }

}
